/**
 * UTC-based date formatting utility to prevent React hydration errors.
 *
 * Using UTC timezone ensures server and client render identical date strings,
 * avoiding React Error #418 (hydration mismatch) that occurs when the server
 * and client are in different timezones.
 */

export function formatDate(
  dateString: string | Date,
  options: { format?: 'short' | 'long' } = {}
): string {
  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
  const { format = 'long' } = options;

  // Use UTC timezone to ensure server/client consistency
  const formatOptions: Intl.DateTimeFormatOptions = {
    timeZone: 'UTC',
    month: format === 'short' ? 'short' : 'long',
    day: 'numeric',
    year: 'numeric',
  };

  return new Intl.DateTimeFormat('en-US', formatOptions).format(date);
}
